export default __webpack_public_path__ + "assets/18d9acabfc2582d0572e1549fb70a960.svg";